import react, { useState, useCallback, useEffect, useMemo } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import useAlertConfirmStore from 'zustands/useAlertConfirmStore';
import { addComma } from 'constants/utils';
import SectionSumInput from './SectionSumInput';
import SectionWorkTimeInput from './SectionWorkTimeInput';
import { IEmpInPayTransfer, IFormDataInPaystatement, IPayItemInPaystatement } from 'types/salary';
import './salary.scss';

interface IProps {
  PRO_DATAS: IPayItemInPaystatement[];
  PRO_DATAS2: IPayItemInPaystatement[];
  DEDUC_DATAS: IPayItemInPaystatement[];
  PAYDATA: IFormDataInPaystatement;
  setPAYDATA: React.Dispatch<React.SetStateAction<IFormDataInPaystatement>>;
  PAYDATA2: IFormDataInPaystatement;
  setPAYDATA2: React.Dispatch<React.SetStateAction<IFormDataInPaystatement>>;
  empList: IEmpInPayTransfer[];
  PAYTYPE: string;
  plusMinusToggle: (name: string) => void;
  payAutoSum: (isSecondDefaultPay?: boolean) => void;
  AddZeroValue: (NAME: any) => void;
  useSecondDefaultPay: boolean;
}

const PayTable = ({
  PRO_DATAS,
  PRO_DATAS2,
  DEDUC_DATAS,
  PAYDATA,
  setPAYDATA,
  PAYDATA2,
  setPAYDATA2,
  empList,
  PAYTYPE,
  plusMinusToggle,
  payAutoSum,
  AddZeroValue,
  useSecondDefaultPay,
}: IProps) => {
  const { setModalState } = useAlertConfirmStore();

  const SetInputData = () => {
    if (PRO_DATAS.length > 0 && PRO_DATAS2.length > 0 && DEDUC_DATAS.length > 0) {
      let datas = {};
      let datas2 = {};
      let TOTALPAY = 0;
      let DEDUCPAY = 0;
      let REALPAY = 0;
      PRO_DATAS.map((pro: IPayItemInPaystatement) => {
        const NAME = pro.ITEM;
        const VALUE = pro.VALUE;
        // console.log('PAYTYPE', PAYTYPE);
        // console.log("pro", pro);
        if (NAME == '기본급') {
          if (PAYTYPE == '시급') {
            const hasWeekMin = pro.VALUE.split(',').length > 5;
            TOTALPAY =
              TOTALPAY + Number(pro.VALUE.split(',').length > 5 ? pro.VALUE.split(',')[5] : pro.VALUE.split(',')[4]);
            datas = {
              ...datas,
              근무시간: pro.VALUE.split(',')[0],
              근무분: pro.VALUE.split(',')[1],
              시급: addComma(pro.VALUE.split(',')[2]),
              주휴수당시간: pro.VALUE.split(',')[3],
              주휴수당분: hasWeekMin ? pro.VALUE.split(',')[4] : '0',
              근무일수: '0',
              일급: '0',
              [NAME]: addComma(hasWeekMin ? pro.VALUE.split(',')[5] : pro.VALUE.split(',')[4]),
            };
          } else if (PAYTYPE == '일급') {
            TOTALPAY = TOTALPAY + Number(pro.VALUE.split(',')[2]);
            datas = {
              ...datas,
              근무시간: '0',
              근무분: '0',
              시급: '0',
              주휴수당시간: '0',
              주휴수당분: '0',
              근무일수: pro.VALUE.split(',')[0],
              일급: addComma(pro.VALUE.split(',')[1]),
              [NAME]: addComma(pro.VALUE.split(',')[2]),
            };
          } else {
            TOTALPAY = TOTALPAY + Number(pro.VALUE.split(',')[2]);
            datas = {
              ...datas,
              근무시간: pro.VALUE.split(',')[0],
              근무분: pro.VALUE.split(',')[1],
              시급: '0',
              주휴수당시간: '0',
              주휴수당분: '0',
              근무일수: '0',
              일급: '0',
              [NAME]: addComma(pro.VALUE.split(',')[2]),
            };
          }
        } else if (NAME == '연장근로수당') {
          TOTALPAY = TOTALPAY + Number(pro.VALUE.split(',')[2]);
          datas = {
            ...datas,
            연장근로시간: pro.VALUE.split(',')[0],
            연장근로분: pro.VALUE.split(',')[1],
            [NAME]: addComma(pro.VALUE.split(',')[2]),
          };
        } else if (NAME == '야간근로수당') {
          TOTALPAY = TOTALPAY + Number(pro.VALUE.split(',')[2]);
          datas = {
            ...datas,
            야간근로시간: pro.VALUE.split(',')[0],
            야간근로분: pro.VALUE.split(',')[1],
            [NAME]: addComma(pro.VALUE.split(',')[2]),
          };
        } else if (NAME == '휴일근로수당') {
          TOTALPAY = TOTALPAY + Number(pro.VALUE.split(',')[2]);
          datas = {
            ...datas,
            휴일근로시간: pro.VALUE.split(',')[0],
            휴일근로분: pro.VALUE.split(',')[1],
            [NAME]: addComma(pro.VALUE.split(',')[2]),
          };
        } else {
          TOTALPAY = TOTALPAY + Number(pro.VALUE);
          datas = {
            ...datas,
            [NAME]: pro.USE_YN === 'Y' ? addComma(pro.VALUE) : 0,
          };
        }
      });

      let pro_data = PRO_DATAS2[0].VALUE;
      if (pro_data === '0') {
        datas2 = {
          근무시간: pro_data,
          근무분: pro_data,
          시급: pro_data,
          주휴수당시간: pro_data,
          주휴수당분: pro_data,
          기본급: pro_data,
        };
      } else {
        datas2 = {
          근무시간: pro_data.split(',')[0],
          근무분: pro_data.split(',')[1],
          시급: addComma(pro_data.split(',')[2]),
          주휴수당시간: pro_data.split(',')[3],
          주휴수당분: pro_data.split(',')[4],
          기본급: addComma(pro_data.split(',')[5]),
        };

        TOTALPAY += Number(pro_data.split(',')[5]);
      }

      DEDUC_DATAS.map((deduc) => {
        // console.log('deduc.VALUE---', deduc.VALUE);
        const NAME = deduc.ITEM;
        if (NAME.includes('두루누리지원금') || deduc.isMinus) {
          DEDUCPAY = DEDUCPAY - Math.abs(Number(deduc.VALUE));
        } else {
          DEDUCPAY = DEDUCPAY + Number(deduc.VALUE);
        }
        // 지급에 같은 이름의 항목이 있는 경우 임의로 _D 붙여서 구분
        if (datas.hasOwnProperty(NAME)) {
          datas = {
            ...datas,
            [NAME + '_D']: deduc.USE_YN === 'Y' ? addComma(deduc.VALUE) : 0,
          };
        } else {
          datas = {
            ...datas,
            [NAME]: deduc.USE_YN === 'Y' ? addComma(deduc.VALUE) : 0,
          };
        }
      });
      REALPAY = TOTALPAY - DEDUCPAY;
      datas = {
        ...datas,
        총지급액: addComma(TOTALPAY.toString()),
        총공제액: addComma(DEDUCPAY.toString()),
        실지급액: addComma(REALPAY.toString()),
      };
      setPAYDATA(datas);
      setPAYDATA2(datas2);
    } else {
      setPAYDATA({});
    }
  };

  // 금액란 입력
  const HandlePayInput = (e: React.ChangeEvent<HTMLInputElement>, isSecondDefaultPay = false) => {
    const { name, value } = e.target;
    if (isSecondDefaultPay) {
      setPAYDATA2({
        ...PAYDATA2,
        [name]: value,
      });
    } else {
      setPAYDATA({
        ...PAYDATA,
        [name]: value,
      });
    }
  };
  // 근무시간 입력
  const HandlePayInput2 = (e: React.ChangeEvent<HTMLInputElement>, isSecondDefaultPay = false) => {
    const { name, value } = e.target;
    // console.log('PAYDATA@@', PAYDATA);
    // console.log('name@@', name);
    // console.log('value', value);
    let NAME = name;
    if (name == '기본급') NAME = '근무시간';
    if (name == '연장근로수당') NAME = '연장근로시간';
    if (name == '야간근로수당') NAME = '야간근로시간';
    if (name == '휴일근로수당') NAME = '휴일근로시간';
    if (
      name == '근무분' ||
      name == '주휴수당분' ||
      name == '연장근로분' ||
      name == '야간근로분' ||
      name == '휴일근로분'
    ) {
      if (Number(value) >= 60) {
        setModalState({
          isModalShow: true,
          title: '시간 입력',
          desc: `0~59사이의 분단위 값을 입력해 주세요`,
        });
        if (!isSecondDefaultPay) {
          setPAYDATA({ ...PAYDATA, [NAME]: '' });
          return;
        } else {
          setPAYDATA2({ ...PAYDATA2, [NAME]: '' });
          return;
        }
      }
    }
    if (isNaN(Number(value))) {
      setModalState({
        isModalShow: true,
        title: '시간 입력',
        desc: `숫자만 입력해 주세요`,
      });
      if (!isSecondDefaultPay) {
        setPAYDATA({ ...PAYDATA, [NAME]: '' });
        return;
      } else {
        setPAYDATA2({ ...PAYDATA2, [NAME]: '' });
        return;
      }
      return;
    } else {
      if (!isSecondDefaultPay) {
        setPAYDATA({ ...PAYDATA, [NAME]: value });
        return;
      } else {
        setPAYDATA2({ ...PAYDATA2, [NAME]: value });
        return;
      }
    }
  };
  // 금액 콤마 추가
  function handlePay(e: React.KeyboardEvent<HTMLInputElement>, isSecondDefaultPay = false) {
    const { name, value } = e.currentTarget;
    let valueFormat = value.split(',').join('');
    if (isNaN(Number(valueFormat))) {
      if (!isSecondDefaultPay) {
        setPAYDATA({ ...PAYDATA, [name]: '' });
      } else {
        setPAYDATA2({ ...PAYDATA2, [name]: '' });
      }
      setModalState({
        isModalShow: true,
        title: '금액 입력',
        desc: `올바른 금액을 입력해 주세요`,
      });
    } else if (value == '') {
      if (!isSecondDefaultPay) {
        setPAYDATA({ ...PAYDATA, [name]: '' });
      } else {
        setPAYDATA2({ ...PAYDATA2, [name]: '' });
      }
    } else {
      if (!isSecondDefaultPay) {
        setPAYDATA({ ...PAYDATA, [name]: addComma(Number(valueFormat).toString()) });
      } else {
        setPAYDATA2({ ...PAYDATA2, [name]: addComma(Number(valueFormat).toString()) });
      }
    }
  }

  const GetCount = (type: '0' | '1') => {
    let COUNT = 0;
    if (type == '0') {
      PRO_DATAS.map((item) => {
        if (item.USE_YN == 'Y') ++COUNT;
      });
      if (useSecondDefaultPay) {
        ++COUNT;
      }
    } else {
      DEDUC_DATAS.map((item) => {
        if (item.USE_YN == 'Y') ++COUNT;
      });
    }
    return COUNT;
  };

  useEffect(() => {
    SetInputData();
  }, [PRO_DATAS, PRO_DATAS2, DEDUC_DATAS]);

  return (
    <div className="SSPTable">
      <table>
        <colgroup>
          <col width="8%" />
          <col width="22%" />
          <col width="30%" />
          <col width="40%" />
        </colgroup>
        <thead>
          <tr>
            <th>구분</th>
            <th>항목</th>
            <th>시간</th>
            <th>금액</th>
          </tr>
        </thead>
        <tbody>
          {empList.length > 0 ? (
            <>
              {PRO_DATAS.length > 0 &&
                PRO_DATAS.map((provide, index) => {
                  if (provide.USE_YN == 'Y') {
                    return (
                      <>
                        <tr key={`productItem_${provide.ITEM_INDEX}_${provide.ITEM}`}>
                          {index == 0 && <td rowSpan={GetCount('0')}>지급</td>}
                          {provide.ITEM == '기본급' && PAYTYPE == '직접입력' ? (
                            <td>
                              <p>{provide.ITEM}</p>
                              <p>(주휴수당포함)</p>
                            </td>
                          ) : provide.ITEM == '식대' ||
                            provide.ITEM == '자가운전보조금' ||
                            provide.ITEM == '육아수당' ? (
                            <td>
                              <p>{provide.ITEM}</p>
                              <p>(비과세)</p>
                            </td>
                          ) : (
                            <td>{provide.ITEM}</td>
                          )}
                          <td>
                            {(provide.ITEM == '기본급' ||
                              provide.ITEM == '연장근로수당' ||
                              provide.ITEM == '야간근로수당' ||
                              provide.ITEM == '휴일근로수당') && (
                              <SectionWorkTimeInput
                                NAME={provide.ITEM}
                                PAYDATA={PAYDATA}
                                HandlePayInput={HandlePayInput}
                                HandlePayInput2={HandlePayInput2}
                                PAYTYPE={PAYTYPE}
                                handlePay={handlePay}
                                payAutoSum={payAutoSum}
                                AddZeroValue={AddZeroValue}
                              />
                            )}
                          </td>
                          <td>
                            <SectionSumInput
                              NAME={provide.ITEM}
                              PAYDATA={PAYDATA}
                              HandlePayInput={HandlePayInput}
                              handlePay={handlePay}
                            />
                          </td>
                        </tr>
                        {provide.ITEM == '기본급' && useSecondDefaultPay === true && (
                          <tr key={`productItem2_${provide.ITEM_INDEX}_${provide.ITEM}`}>
                            <td>기본급2</td>
                            <td>
                              <SectionWorkTimeInput
                                NAME={provide.ITEM}
                                PAYDATA={PAYDATA2}
                                HandlePayInput={(e) => HandlePayInput(e, true)}
                                HandlePayInput2={(e) => HandlePayInput2(e, true)}
                                PAYTYPE={PAYTYPE}
                                handlePay={(e) => handlePay(e, true)}
                                payAutoSum={() => payAutoSum(true)}
                                AddZeroValue={AddZeroValue}
                              />
                            </td>
                            <td>
                              <SectionSumInput
                                NAME={provide.ITEM}
                                PAYDATA={PAYDATA2}
                                HandlePayInput={(e) => HandlePayInput(e, true)}
                                handlePay={(e) => handlePay(e, true)}
                              />
                            </td>
                          </tr>
                        )}
                      </>
                    );
                  } else {
                    null;
                  }
                })}
              <tr style={{ backgroundColor: '#f0f8f6' }}>
                <td colSpan={3}>총지급액</td>
                <td>
                  <div className="AmountTd">
                    <div>{PAYDATA['총지급액']}</div>
                  </div>
                </td>
              </tr>
              {PAYDATA['총지급액'] !== '0' && (
                <>
                  {DEDUC_DATAS.length > 0 &&
                    DEDUC_DATAS.map((deduction, index) => {
                      if (deduction.USE_YN == 'Y') {
                        return (
                          <tr key={`deductionItem_${deduction.ITEM_INDEX}_${deduction.ITEM}`}>
                            {index == 0 && <td rowSpan={GetCount('1')}>공제</td>}
                            <td>{deduction.ITEM.replace('_D', '')}</td>
                            {deduction.ITEM.includes('두루누리지원금') ? (
                              <td>공제액 차감 항목</td>
                            ) : deduction.ITEM == '건강보험료 정산' ||
                              deduction.ITEM == '고용보험 정산' ||
                              deduction.ITEM == '국민연금 정산' ? (
                              <td>공제액 증가,차감 선택항목</td>
                            ) : (
                              <td></td>
                            )}
                            <td>
                              <SectionSumInput
                                NAME={deduction.ITEM}
                                PAYDATA={PAYDATA}
                                HandlePayInput={HandlePayInput}
                                handlePay={handlePay}
                                isMinus={deduction.isMinus}
                                plusMinusToggle={plusMinusToggle}
                              />
                            </td>
                          </tr>
                        );
                      } else {
                        null;
                      }
                    })}
                  <tr style={{ backgroundColor: '#f0f8f6' }}>
                    <td colSpan={3}>총공제액</td>
                    <td>
                      <div className="AmountTd">
                        <div>{PAYDATA['총공제액']}</div>
                      </div>
                    </td>
                  </tr>
                  <tr style={{ backgroundColor: '#f0f8f6' }}>
                    <td colSpan={3}>실지급액</td>
                    <td>
                      <div className="AmountTd">
                        <div>{PAYDATA['실지급액']}</div>
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default PayTable;
